import { useState, useEffect } from "react";
import moment from "moment";
import InputNumber from "../../../../../shared/components/inputs/InputNumber/InputNumber";
import InputText from "../../../../../shared/components/inputs/InputText/InputText";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { useLoading } from "../../../../../shared/context/LoadingContext";
import toast from "react-hot-toast";

import { fixSpaces } from "../../../../../shared/util/helperFunctions";

import "./ModalEntrada.scss";

function ModalEditarEntrada({
  openModalEditarEntrada,
  handleCloseModalEditarEntrada,
  sendRequest,
  clinicaId,
  entradaId,
  updateEntradas,
  auth,
  modoContingenciaAtivo,
}) {
  const { startLoading, stopLoading } = useLoading();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openModal, setOpenModal] = useState(openModalEditarEntrada);
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState(0);
  const [observacao, setObservacao] = useState("");
  const [categoria, setCategoria] = useState();
  const [categorias, setCategorias] = useState([]);
  const [dataLimitePagamento, setDataLimitePagamento] = useState(
    moment().add(1, "M")
  );
  const [clientesFornecedores, setClientesFornecedores] = useState([]);
  const [clienteFornecedor, setClienteFornecedor] = useState();

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const [categoriasResponse, entradaResponse] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasfinanceiro/clinica/entrada/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/${entradaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token }
          ),
        ]);

        // Process categorias
        const categoriasFormatted = categoriasResponse.categoriasFinanceiro.map(
          (cat) => ({
            id: cat.id,
            value: cat.categoria,
          })
        );

        //Verificar se a categoria ja foi desativada ou não
        //Se sim, adicionamo-la à lista de categorias pois se trata de uma edição
        const isCategoriaActive = categoriasFormatted.find(
          (catF) => catF.id === entradaResponse.entrada.categoria._id
        );
        if (!isCategoriaActive) {
          categoriasFormatted.push({
            id: entradaResponse.entrada.categoria._id,
            value: entradaResponse.entrada.categoria.categoria,
          });
        }

        setCategorias(categoriasFormatted);
        setCategoria(categoriasFormatted[0]?.id);

        // Process entrada
        const { entrada } = entradaResponse;
        setClienteFornecedor(entrada.clienteFornecedor?.id);
        setCategoria(entrada.categoria.id);

        setValor(entrada.valor);
        setDescricao(entrada.descricao);
        setObservacao(entrada.observacao || "");
        setDataLimitePagamento(moment(entrada.dataLimitePagamento));

        const clientesFornecedoresResponse = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/clientesfornecedores/clinica/${clinicaId}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token }
        );

        // Process clientesFornecedores
        setClientesFornecedores(
          clientesFornecedoresResponse.clientesFornecedores.map((cf) => ({
            id: cf.id,
            value: cf.nome,
          }))
        );
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [clinicaId, sendRequest, entradaId, auth.token]);

  useEffect(() => {
    setOpenModal(openModalEditarEntrada);
  }, [openModalEditarEntrada]);

  const descricaoChangeHandler = (value) => {
    setDescricao(value);
  };

  const valorChangeHandler = (value) => {
    setValor(value);
  };

  const editarEntradaHandler = async (emit) => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("tipoEntrada", "clienteFornecedor");

      formData.append("observacoes", observacao);
      formData.append("descricao", fixSpaces(descricao));
      formData.append("valor", valor);
      formData.append("categoria", categoria);
      formData.append("atualizadoPor", auth.userId);

      formData.append(
        "clienteFornecedor",
        clienteFornecedor.id ? clienteFornecedor.id : clienteFornecedor
      );
      formData.append("dataLimitePagamento", dataLimitePagamento);

      //LEMBRA DE ADICIONAR COMPROVATIVO MAIS TARDE
      const entradaAtualizada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/entradas/${entradaId}`,
        "PATCH",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        }
      );
      if (emit) {
        updateEntradas(entradaAtualizada.entrada, "atualizar", emit);
      } else {
        toast.success("Entrada atualizada com sucesso!");
        updateEntradas(entradaAtualizada.entrada, "atualizar");
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      handleCloseModalEditarEntrada();
      setIsSubmitting(false);
    }
  };

  const preGuardarEntradaHandler = (e, emit) => {
    if (valor === 0 || valor < 0) {
      toast.error("O valor da entrada não pode ser 0 ou menor que 0.");
    } else if (!descricao || descricao.trim() === "") {
      toast.error("Introduza a descrição");
    } else if (!clienteFornecedor) {
      toast.error("Escolha o Cliente Financeiro");
    } else if (!dataLimitePagamento) {
      toast.error("Introduza a data de limite de Pagamento");
    } else if (
      !moment.isMoment(dataLimitePagamento) ||
      !dataLimitePagamento.isValid()
    ) {
      toast.error("Introduza a data de limite de pagamento corretamente");
    } else if (!categoria) {
      toast.error("Introduza uma categoria");
    } else if (!isSubmitting) {
      setIsSubmitting(true);
      editarEntradaHandler(emit);
    }
  };

  return (
    <>
      <Modal
        open={openModal}
        onClose={handleCloseModalEditarEntrada}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box adicionar-entrada__modal"
          id="modal__adicionar-entrada"
        >
          <h1 className="fluxo-atendimento__modal__titulo">Editar entrada</h1>
          {/* {entrada && ( */}
          <div className="adicionar-entrada__modal__container">
            <InputText
              className="adicionar-entrada__modal__container--span2"
              label="Descrição *"
              initialValue={descricao}
              handleChange={descricaoChangeHandler}
            />

            {clientesFornecedores && clienteFornecedor && (
              <div className="customInputContainer adicionar-entrada__modal__container--span2">
                <select
                  onChange={(e) => setClienteFornecedor(e.target.value)}
                  className="customInputSelect"
                  value={clienteFornecedor}
                >
                  {clientesFornecedores &&
                    clienteFornecedor &&
                    clientesFornecedores.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">
                  Cliente Financeiro
                </label>
              </div>
            )}

            <InputNumber
              className="adicionar-entrada__modal__container--span1"
              label="Valor *"
              initialValue={valor}
              handleChange={valorChangeHandler}
            />

            <LocalizationProvider
              dateAdapter={AdapterMoment}
              className="adicionar-entrada__modal__container--span1"
            >
              <DesktopDatePicker
                className="valorDataCaixa__fields--field muiDatePicker"
                label="Data limite pagamento*"
                inputFormat="DD-MM-YYYY"
                value={dataLimitePagamento}
                onChange={(value) => setDataLimitePagamento(value)}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            {categorias && categoria && (
              <div className="customInputContainer adicionar-entrada__modal__container--span2">
                <select
                  onChange={(e) => setCategoria(e.target.value)}
                  className="customInputSelect"
                  value={categoria}
                >
                  {categorias &&
                    categoria &&
                    categorias.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">Categoria</label>
              </div>
            )}

            <textarea
              cols="30"
              rows="7"
              placeholder="observacao"
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              className="adicionar-entrada__modal__container__textarea"
            ></textarea>
          </div>

          <div className="fluxo-atendimento__modal__bottom_btns">
            <span
              className="cancel-btn"
              onClick={handleCloseModalEditarEntrada}
              style={{ display: "block" }}
            >
              Fechar
            </span>
            <span
              disabled={isSubmitting}
              className="blue-button"
              onClick={preGuardarEntradaHandler}
            >
              {isSubmitting ? "Guardando..." : "Guardar"}
            </span>
            <span
              disabled={isSubmitting}
              className={"blue-button"}
              onClick={preGuardarEntradaHandler.bind(null, null, "emitirFTE")}
            >
              {isSubmitting
                ? "Guardando..."
                : `Guardar e emitir FTE ${
                    modoContingenciaAtivo ? " (Contingência)" : ""
                  }`}
            </span>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default ModalEditarEntrada;
